import { AxiosGet, AxiosPost } from "../useApi";


export function GetTPSLookUp(params) {
    const route = 'tps/lookup';
    return AxiosGet(route, params);
}

export function OverrideTPS(params, data) { 
    const route = 'tps/override';
    return AxiosPost(route, params, data);
}